(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-nodus-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nodus-grid')) {
  class NodusGrid extends HTMLElement {
    connectedCallback() {
      this.boundUpdate = this.updateLayout.bind(this);
      this.breakpoint = Number(this.dataset.mobileBreakpoint) || 749;
      this.mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint}px)`);

      this.resizeObserver = new ResizeObserver(this.boundUpdate);
      this.resizeObserver.observe(this);

      this.mediaQuery.addEventListener('change', this.boundUpdate);

      this.inView = false;
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          this.inView = entries.some((entry) => entry.isIntersecting);
          this.#hydrateVideos();
        },
        { rootMargin: '200px 0px' }
      );
      this.intersectionObserver.observe(this);

      this.updateLayout();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.mediaQuery?.removeEventListener('change', this.boundUpdate);

      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }
    }

    updateLayout() {
      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }

      this.raf = requestAnimationFrame(() => {
        this.#applyLayout();
        this.#hydrateVideos();
      });
    }

    #applyLayout() {
      const width = this.clientWidth;

      if (width <= 0) {
        return;
      }

      const isMobile = this.mediaQuery.matches;
      const designWidth = Number(this.dataset.designWidth) || 1200;
      const videoRatio = Number(this.dataset.videoRatio) || 9 / 16;
      const gapBase = isMobile
        ? Number(this.dataset.gapMobile) || 12
        : Number(this.dataset.gap) || 16;

      this.classList.toggle('is-mobile', isMobile);

      if (isMobile) {
        this.#layoutMobile(width, gapBase);
      } else {
        this.#layoutDesktop(width, designWidth, gapBase, videoRatio);
      }

      this.classList.add('is-ready');
    }

    #layoutDesktop(width, designWidth, gapBase, videoRatio) {
      const scale = width / designWidth;
      const gap = gapBase * scale;
      const large = Math.max(0, (width - 1.5 * gap) / (1.5 + videoRatio));
      const small = Math.max(0, (large - gap) / 2);
      const video = large * videoRatio;

      this.style.setProperty('--nodus-grid-gap', `${gap}px`);
      this.style.setProperty('--nodus-grid-large', `${large}px`);
      this.style.setProperty('--nodus-grid-small', `${small}px`);
      this.style.setProperty('--nodus-grid-video', `${video}px`);
    }

    #layoutMobile(width, gapBase) {
      const mobileDesign = this.breakpoint;
      const scale = width / mobileDesign;
      const gap = gapBase * scale;
      const small = Math.max(0, (width - gap) / 2);
      const top = small * 2;

      this.style.setProperty('--nodus-grid-gap', `${gap}px`);
      this.style.setProperty('--nodus-grid-small', `${small}px`);
      this.style.setProperty('--nodus-grid-large', `${width}px`);
      this.style.setProperty('--nodus-grid-video', `${small}px`);
      this.style.setProperty('--nodus-grid-top', `${top}px`);
    }

    #hydrateVideos() {
      const isMobile = this.mediaQuery.matches;
      const medias = this.querySelectorAll('[data-grid-media]');

      for (const media of medias) {
        const viewport = media.getAttribute('data-grid-media');
        const shouldShow =
          viewport === 'both' ||
          (isMobile && viewport === 'mobile') ||
          (!isMobile && viewport === 'desktop');

        const template = media.querySelector('[data-grid-video-template]');
        let video = media.querySelector('video');

        if (!this.inView) {
          video?.pause();
          continue;
        }

        if (shouldShow && template && !video) {
          media.appendChild(template.content.cloneNode(true));
          video = media.querySelector('video');
        }

        if (!video) {
          continue;
        }

        if (shouldShow) {
          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      }
    }
  }

  customElements.define('nodus-grid', NodusGrid);
}

  } catch(e) { console.error(e); }
})();
})();
